import { Download } from 'lucide-react';
import { useInstallPrompt } from '../hooks/useInstallPrompt';

export function InstallPrompt() {
  const { canInstall, isStandalone, promptInstall } = useInstallPrompt();

  if (isStandalone) {
    return <span className="mini-pill success">Installed</span>;
  }

  if (!canInstall) {
    return <span className="mini-pill">PWA ready</span>;
  }

  return (
    <button className="icon-action" type="button" onClick={promptInstall} aria-label="Install SOS Signal">
      <Download size={17} aria-hidden="true" />
    </button>
  );
}
